'use client';

import React from 'react';
import Header from '@/components/common/Header';
import ResourceDiscoveryInteractive from './components/ResourceDiscoveryInteractive';

export default function ResourceDiscoveryCenterPage() {
  return (
    <>
      <Header data-component-id="src/app/resource-discovery-center/page.tsx:10:6" data-component-path="src/app/resource-discovery-center/page.tsx" data-component-line="10" data-component-end-line="10" data-component-file="page.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />
      <main data-component-id="src/app/resource-discovery-center/page.tsx:11:6" data-component-path="src/app/resource-discovery-center/page.tsx" data-component-line="11" data-component-end-line="13" data-component-file="page.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22pt-16%22%7D" className="pt-16">
        <ResourceDiscoveryInteractive data-component-id="src/app/resource-discovery-center/page.tsx:12:8" data-component-path="src/app/resource-discovery-center/page.tsx" data-component-line="12" data-component-end-line="12" data-component-file="page.tsx" data-component-name="ResourceDiscoveryInteractive" data-component-content="%7B%22elementName%22%3A%22ResourceDiscoveryInteractive%22%7D" />
      </main>
    </>
  );
}
